// @flow
import React from 'react';
import { Box, Button } from 'grommet';
import UpperContainer from 'esm-web-pro/components/layout/sidePanel/UpperContainer';
import sidePanelMessages from 'esm-web-pro/messages/sidePanelMessages';
import ButtonContainer from 'esm-web-pro/components/layout/sidePanel/ButtonContainer';
import { injectIntl, IntlShape } from 'react-intl';
import Title from 'esm-web-pro/components/layout/sidePanel/Title';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import MapActions from 'esm-web-pro/containers/map/sidepane/MapActions';
import type { LeafletContext } from 'react-leaflet/lib/types';
import { withLeaflet } from 'react-leaflet';


type Props = {
    title: string,
    onClose: () => void,
    intl: IntlShape,
    updatingObject: Object,
    loading: boolean,
    editor: Class,
    handleDeleteClick: Function,
    leaflet: LeafletContext,
    resource: Object,
};

function MapSidePaneInfo(props: Props) {
    const {
        onClose, intl: { formatMessage }, intl, title, updatingObject,
        loading, editor, handleDeleteClick, leaflet: { map }, resource,
    } = props;

    const onView = () => {
        if (map) {
            map.highlightedGeometry = {
                bounds: updatingObject.layer._latlngs[0], center: null,
            };
            map.panInsideBounds(updatingObject.layer._latlngs[0]);
            map.flyToBoundsCenter(map.highlightedGeometry.bounds, map.highlightedGeometry.center, true);
        }
    };

    React.useEffect(() => {
        onView();
    }, [updatingObject.layer.feature.id]);

    return (
        <Box height="100%" justify="between">
            <Box pad={{ left: '25px' }}>
                <Title text={title} onView={onView} />
            </Box>
            <Box flex>
                <UpperContainer>
                    <HorizontalLine color="grey" />
                    <Box direction="row">
                        <MapActions
                            updatingObject={updatingObject}
                            intl={intl}
                            loading={loading}
                            editor={editor}
                            handleDeleteClick={(e) => handleDeleteClick(e)}
                            resource={resource}
                        />
                    </Box>
                    <HorizontalLine color="grey" />
                </UpperContainer>
            </Box>
            <ButtonContainer handleClick={onClose} />
        </Box>
    );
}

export default withLeaflet(injectIntl(MapSidePaneInfo));
